module.exports = __webpack_public_path__ + "static/EstrellaMuerte-a5e77635237ff7531b977fa1646c5111.jpg";